// extracted by mini-css-extract-plugin
module.exports = {"checkboxName":"_1Z3y8GmFotpyao8tFpx7qF"};